﻿var pageTitleActions = require("@cirrus/legacy/app-author/common/page-title-component/actions")
var BaseRouter = Marionette.AppRouter.extend({
  initialize: function () {
    this.isFirstLoad = true
  },
  notFound: function () {
    window.location.hash = "#"
  },
  changeModule: function (name, mainMenu) {
    if (name === window.currentModuleNameOldMarionetteRouter) {
      return window.currentModuleOldMarionetteRouter
    }

    this.stopCurrent(window.currentModuleNameOldMarionetteRouter)
    pageTitleActions.cleanTitle()
    var m = App.module(name)
    window.currentModuleOldMarionetteRouter = m
    window.currentModuleNameOldMarionetteRouter = name
    this.mainMenu = mainMenu
    $("body")
      .attr("page", name.replace(".", "-").toLowerCase())
      .attr("data-useragent", navigator.userAgent)
    this.isFirstLoad = false
    return m
  },
  stopCurrent: function (name) {
    // if (name && name.indexOf("Admin.") != 0)
    //     App.module("Admin.Sidebar").stop();
    var m = window.currentModuleOldMarionetteRouter

    if (m && (m.fullName === name || m.moduleName === name)) {
      window.currentModuleOldMarionetteRouter = null
      window.currentModuleNameOldMarionetteRouter = null
      m.stop()
    }

    return m
  },
})

module.exports = BaseRouter
